'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import salsify from 'salsify-experiences-sdk';
import { logger } from '@libs/core';
const SALSIFY_ORIGIN = 'salsify';
const SALSIFY_EMPTY_CONTENT_HEIGHT = 1;
const SALSIFY_HEIGHT_SETTLE_TIMEOUT = 2 * 1000;
const SALSIFY_LOAD_TIMEOUT = 15 * 1000;
const browserGlobal = globalThis as typeof globalThis & Pick<Window, 'flags'>;
export type UseSalsifyContentProps = {
  productId: string;
  salsifyClientId: string;
  salsifyIdType: string;
};
type SalsifyAvailability = {
  productId: string;
  found?: boolean;
};
export function useSalsifyContent(t0) {
  const $ = _c(7);
  const {
    salsifyClientId,
    salsifyIdType,
    productId
  } = t0;
  let t1;
  if ($[0] !== productId) {
    t1 = {
      productId
    };
    $[0] = productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [availability, setAvailability] = useState(t1);
  const salsifyFound = availability.productId === productId ? availability.found : undefined;
  let t2;
  let t3;
  if ($[2] !== productId || $[3] !== salsifyClientId || $[4] !== salsifyIdType) {
    t2 = () => {
      let active = true;
      let heightSettleTimeout;
      let loadTimeout;
      let iframe = null;
      const target = document.querySelector("#salsify-target") as HTMLDivElement | null;
      setAvailability({
        productId
      });
      if (browserGlobal.flags?.IS_PERFORMANCE_MODE || !salsifyClientId || !salsifyIdType || !target) {
        setAvailability({
          productId,
          found: false
        });
        return;
      }
      target.replaceChildren();
      const setUnavailable = () => {
        if (!active) {
          return;
        }
        clearTimeout(heightSettleTimeout);
        clearTimeout(loadTimeout);
        iframe?.removeEventListener("load", handleIframeLoad);
        target.replaceChildren();
        setAvailability({
          productId,
          found: false
        });
      };
      const setAvailable = () => {
        if (!active) {
          return;
        }
        clearTimeout(heightSettleTimeout);
        clearTimeout(loadTimeout);
        setAvailability({
          productId,
          found: true
        });
      };
      const settleIframeAvailability = () => {
        const height = Number(iframe?.height);
        if (Number.isFinite(height) && height > SALSIFY_EMPTY_CONTENT_HEIGHT) {
          setAvailable();
        } else {
          setUnavailable();
        }
      };
      const handleIframeLoad = () => {
        clearTimeout(loadTimeout);
        heightSettleTimeout = setTimeout(settleIframeAvailability, SALSIFY_HEIGHT_SETTLE_TIMEOUT);
      };
      const handleMessage = event => {
        const height_0 = Number(event.data?.height);
        if (!active || !event.origin.includes(SALSIFY_ORIGIN) || !Number.isFinite(height_0) || height_0 <= SALSIFY_EMPTY_CONTENT_HEIGHT) {
          return;
        }
        const renderedIframe = target.querySelector("#salsify-ec-iframe") as HTMLIFrameElement | null;
        if (renderedIframe) {
          renderedIframe.height = String(height_0);
          renderedIframe.style.height = `${height_0}px`;
        }
      };
      globalThis.addEventListener("message", handleMessage);
      const checkProduct = async () => {
        ;
        try {
          if (!salsify.initialized) {
            salsify.init({
              clientId: salsifyClientId,
              enhancedContent: {
                idType: salsifyIdType
              }
            });
          }
          const exists = await salsify.enhancedContent.exists(productId);
          if (!active) {
            return;
          }
          if (!exists) {
            setUnavailable();
            return;
          }
          salsify.enhancedContent.renderIframe(target, productId);
          if (!active) {
            return;
          }
          iframe = target.querySelector("#salsify-ec-iframe") as HTMLIFrameElement | null;
          if (!iframe) {
            setUnavailable();
            return;
          }
          iframe.addEventListener("load", handleIframeLoad, {
            once: true
          });
          loadTimeout = setTimeout(setUnavailable, SALSIFY_LOAD_TIMEOUT);
        } catch (t4) {
          const error = t4;
          logger.error("[useSalsify] Failed to load Salsify content", error);
          setUnavailable();
        }
      };
      checkProduct();
      return () => {
        active = false;
        clearTimeout(heightSettleTimeout);
        clearTimeout(loadTimeout);
        iframe?.removeEventListener("load", handleIframeLoad);
        globalThis.removeEventListener("message", handleMessage);
      };
    };
    t3 = [productId, salsifyClientId, salsifyIdType];
    $[2] = productId;
    $[3] = salsifyClientId;
    $[4] = salsifyIdType;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  return salsifyFound;
}